module.exports = __webpack_public_path__ + "static/media/message.43e57250.png";